
<template>
    <div class="signUp bodyfont-unauth">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
<!--                    <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
<!--                        <span class="icon-info-circled alert-icon-float-left"></span>-->
<!--                        <strong>Error:</strong>-->
<!--                        <p id="signup_errormsg">{{error.message}}</p>-->
<!--                    </alert>-->
                    <div class="row margin-top">
                        <div class="col-md-7">
                            <div class="main-content text-left left-content">
                                <hr>
                                <h2>
                                    Welcome to TONE.
                                    <br><span v-if="!codeRedeemed && !isFreePreviewEnabled && showPlanForm && paidServiceFlag">You won't be charged until after your free trial. Easy online cancellation.</span>
                                </h2>
                            </div>
                            <div class="choice-holder" v-if="paidServiceFlag && freeServiceFlag">
                                <div class="row">
                                    <div class="col-xs-6">
                                        <div class="innerpart">
                                            Start Your {{getTotalTrialDays}} Day Free Trial
                                            <br />
                                            <button class="gradient-tone-header btn btn-primary btn-lg" :class = "{'active': applyActiveClass('trial')}" @click="togglePlanView('trial')">
                                                Try Now
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-xs-6">
                                        <div class="innerpart">
                                            Become a Member Today
                                            <br />
                                            <button class="gradient-tone-header btn btn-primary btn-lg" @click="togglePlanView('buy')" :class = "{'active': applyActiveClass('buy')}">
                                                Buy Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <transition name="bounce">
                                <div class="left-content" v-if="showPlanForm">
                                    <accordion :one-at-atime="true">
                                        <panel :is-open="true"  class="text-left">
                                            <h4 class="hidemobile" v-if="!isFreePreviewEnabled && showPlanForm && !freeServiceFlag">Start your {{defaultPlan.type}}&nbsp;<span v-if="!codeRedeemed">trial</span></h4>
                                            <h4 class="showmobile" v-if="!isFreePreviewEnabled && showPlanForm && !freeServiceFlag">{{defaultPlan.description}}</h4>
                                            <h4  v-if="showPlanForm && implementFreePlan && freeServiceFlag && !paidServiceFlag">Start Your {{getTotalTrialDays}} Day Free Trial</h4>
                                            <!--<h4 v-if="paymentSection" slot="header" v-on:click="disablePaymentPanel; createSection = !createSection; paymentSection = false; isToggle = true">-->
                                            <!--<h4 v-if="paymentSection" slot="header">-->
                                            <!--1. CREATE AN ACCOUNT-->
                                            <!--<p class="sign-up-info"><b>Email: {{user.email}}</b></p>-->
                                            <!--</h4>-->
                                            <div class="create-account">
                                                <br v-if="!isFreePreviewEnabled && showPlanForm">
                                                <!--<p class="text-center">Fill out your information below.</p>-->
                                                <div class="form">
                                                    <form action="/charge" method="post" id="payment-form" v-on:submit.prevent="onPaymentSubmit">

                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus">
                                                            <bs-input v-model="user.firstName"
                                                                      v-bind:pattern="/^[A-Za-z '-]+$/"
                                                                      name="firstname"
                                                                      id = "signup_firstname"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="First Name (no digits allowed)"
                                                                      placeholder="First Name"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                            <bs-input v-model="user.lastName"
                                                                      v-bind:pattern="/^[A-Za-z '-]+$/"
                                                                      id = "signup_lastname"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="Last Name (no digits allowed)"
                                                                      placeholder="Last Name"
                                                                      name="lastname"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                            <bs-input v-model="user.email"
                                                                      :pattern="emailPattern"
                                                                      id = "signup_email"
                                                                      type="email"
                                                                      class="form-input"
                                                                      error="Email Address"
                                                                      placeholder="Email Address"
                                                                      name="email"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                            <vue-password v-model="user.password"
                                                                          :minlength="6"
                                                                          classes="input form-control"
                                                                          placeholder="Password"
                                                                          error="Password"
                                                                          id = "signup_password"
                                                                          required
                                                                          name="password"
                                                                          :disableStrength = "hidePasswordMeter"
                                                                          icon
                                                            >
                                                            </vue-password>
                                                            <span  class="icon-info-circled alert-icon-float-left information password-error">
                                                        <p class="alert alert-info alert-dismissable password-error-color" :class = "{'set-error': !verifyPassword()}"  id="signup_pwderrormsg">Min 6 Chars, One Upper Case, One Lower Case!</p>
                                                        </span>
                                                            <div class="clearfix"></div>

                                                            <h3 v-if="!codeRedeemed && !implementFreePlan">Become a Member now</h3>
                                                            <div class="clearfix"></div>

                                                            <div class="checkboxholder" v-if="!codeRedeemed && !implementFreePlan">
                                                                <div class="row">
                                                                    <div class="col-sm-4">
                                                                        <div class="radio">
                                                                            <label>
                                                                                <span class="heading">Two Year Plan</span>
                                                                                <span class="plan-price">$8.99<span class="permonth">per month</span></span>
                                                                                <input  v-if= "twoYearPlan" type="radio" id="2yearplan" :value="twoYearPlan.packageId" v-model="packageId" name="planselection" />
                                                                                <span class="footertext">${{twoYearPlan.amount}} billed once</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-4">
                                                                        <div class="radio popular">
                                                                            <label>
                                                                                <span class="heading">One Year Plan</span>
                                                                                <span class="plan-price">$9.50 <span class="permonth">per month</span></span>
                                                                                <input  v-if= "annualPlan" type="radio" id="annualplan" :value="annualPlan.packageId" v-model="packageId" name="planselection" />
                                                                                <span class="footertext">${{annualPlan.amount}} billed annually</span>
                                                                            </label>
                                                                        </div>
                                                                    </div><div class="col-sm-4">
                                                                    <div class="radio">
                                                                        <label>
                                                                            <span class="heading">Monthly Plan</span>
                                                                            <span class="plan-price">${{defaultPlan.amount}} <span class="permonth">per month</span></span>
                                                                            <input  v-if= "defaultPlan" type="radio" id="monthlyplan" :value="defaultPlan.packageId" v-model="packageId" name="planselection" />
                                                                            <span class="footertext">billed monthly</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                </div>

                                                                <!--<div class="radio">
                                                                    <label>
                                                                        <input type="radio" id="regularplan" :value="defaultPlan.packageId" v-model="packageId" name="planselection" />&nbsp;Monthly membership&nbsp;({{ defaultPlan.type }}&nbsp;trial): ${{defaultPlan.amount}}
                                                                    </label>
                                                                </div>
                                                                <div class="radio popular">
                                                                    <label>
                                                                        <input  v-if= "annualPlan" type="radio" id="annualplan" :value="annualPlan.packageId" v-model="packageId" name="planselection" />&nbsp;Annual membership&nbsp;({{ annualPlan.type }}): ${{annualPlan.amount}}
                                                                    </label>
                                                                </div>-->


                                                                <!--<div class="checkbox">-->
                                                                <!--<label>-->
                                                                <!--<input v-if="defaultPlan" v-model="isMonthlySubscription" type="checkbox" disabled/> Monthly membership ${{defaultPlan.amount}}-->
                                                                <!--</label>-->
                                                                <!--</div>-->
                                                                <!--<div class="checkbox">-->
                                                                <!--<label>-->
                                                                <!--<input v-if="annualPlan" type="checkbox" v-model="isAnnualSubscription"/> Annual membership ${{annualPlan.amount}}-->
                                                                <!--</label>-->
                                                                <!--</div>-->
                                                            </div>
                                                            <div class="clearfix"></div>
                                                            <!--<div class="redoutlinebox" v-if="!codeRedeemed && !implementFreePlan">-->
                                                                <!--Special offer! For a limited time, receive a free copy of TONE Expert Debi Silber's latest book, <strong>The Unshakable Woman</strong>, with purchase of an annual membership.-->
                                                            <!--</div>-->
                                                            <div class="clearfix"></div>
                                                            <div class="codediv" v-if="!codeRedeemed && !implementFreePlan">
                                                                <div class="radiowrapper"><input type="radio" id="one" value="CC" v-model="gateway" name="paymentMethod">
                                                                    <label for="one">Credit Card</label>

                                                                    <input type="radio" id="two" value="paypal" v-model="gateway" name="paymentMethod">
                                                                    <label for="two">Paypal</label>
                                                                </div>
                                                                <bs-input id="paymentMethod_cardHolder"
                                                                          v-model = "user.cardHolderName"
                                                                          v-if="gateway === 'CC'"
                                                                          v-bind:pattern="/^[A-Za-z ]+$/"
                                                                          type="text"
                                                                          class="form-input"
                                                                          error="Card Holder Name (no digits allowed)"
                                                                          placeholder="Card Holder Name"
                                                                          required
                                                                          name="cardholdername"
                                                                          icon>
                                                                </bs-input>
                                                                <div class="stripeholder" v-if="gateway==='CC'">
                                                                    <i class="fa fa-lock overlapstripe" v-if="gateway==='CC'"></i>
                                                                    <div id="card-element" class="field"></div>
                                                                    <!-- Used to display form errors -->
                                                                    <div v-if="stripeErrorMessage" role="alert" style="color:#a94442;margin:2px;">{{stripeErrorMessage}}</div>
                                                                </div>
                                                                <div class="row" v-if="gateway==='paypal'">
                                                                    <div class="col-md-4">
                                                                        <div id="paypal-button" class="text-center margin-top-10 margin-bottom-10"></div>
                                                                        <!--<div id="dropin-container"></div>-->
                                                                        <!--<button id="submit-button">Request payment method</button>-->
                                                                    </div>
                                                                    <div style="margin-bottom: 10px" class="col-md-9" v-if="userPayments.paymentMethodNonce">
                                                                  <span  class="icon-info-circled alert-icon-float-left success">
                                                        <p class="alert alert-success alert-dismissable" ><i class="fa fa-check-square-o" aria-hidden="true"></i>Payment successfully authorized</p>
                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="row code">
                                                                <div class="col-sm-8">
                                                                    <bs-input
                                                                        v-model = "giftCode" v-if="!codeRedeemed && !implementFreePlan"
                                                                        type="text"
                                                                        class="form-input"
                                                                        placeholder="Gift Code"
                                                                        name="giftcode"
                                                                        icon>
                                                                    </bs-input>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <button name="redeembutton" v-if="!codeRedeemed && !implementFreePlan" type="button" @click="redeemCode" class="redeem btn formButton btn-block" :disabled="giftCode.length === 0 || spinner">
                                                                        Redeem Your Gift
                                                                        <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <checkbox class="terms-and-condition" v-model="isChecked" value="isChecked" type="primary" id="signuptermsconditionschckbox">
                                                                &nbsp;I agree to <a href="/terms" target="_blank" rel="opener">terms and conditions</a>
                                                                <!--I agree to-->
                                                                <!--<router-link  :to="{ path: '/terms'}">-->
                                                                <!--terms and conditions-->
                                                                <!--</router-link>-->
                                                            </checkbox>
                                                            <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left padding-minus padding-minus-right">-->
                                                            <!--<br>-->
                                                            <!--<img src="../assets/verify.jpg" alt="verified" height="100" width="100">-->
                                                            <!--&lt;!&ndash;</div>&ndash;&gt;-->
                                                            <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left padding-minus padding-minus-right verified-security-content">-->
                                                            <!--&lt;!&ndash;<p>&ndash;&gt;-->
                                                            <!--&lt;!&ndash;Your subscription will automatically continue for as long as you choose to remain a subscriber. Your credit card will be charged at the time of purchase, and once a month for each month following your membership. You will receive an email reminder in advance of your 6-month or annual plan renewal. You may cancel your subscription at any time, however there are no refunds and your membership will stay in effect until the day following your pre-paid date.&ndash;&gt;-->
                                                            <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                                            <!--<p>-->
                                                            <!--Your personal information will be used strictly in accordance with our <strong><router-link class="terms-and-condition" :to="{ path: '/privacypolicy'}">-->
                                                            <!--Privacy Policy-->
                                                            <!--</router-link></strong>-->
                                                            <!--</p>-->
                                                            <!--</div>-->

                                                            <!--<bs-input v-model="user.password"-->
                                                            <!--id = "signup_password"-->
                                                            <!--error="Password"-->
                                                            <!--type="password"-->
                                                            <!--class="form-input"-->
                                                            <!--placeholder="Password"-->
                                                            <!--required-->
                                                            <!--icon>-->
                                                            <!--</bs-input>-->
                                                            <!--<bs-input v-model="confirmPassword"-->
                                                            <!--id = "signup_confirmPassword"-->
                                                            <!--error="Confirm Password"-->
                                                            <!--type="password"-->
                                                            <!--class="form-input"-->
                                                            <!--placeholder="Confirm Password"-->
                                                            <!--required-->
                                                            <!--icon>-->
                                                            <!--</bs-input>-->
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">
                                                            <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->
                                                            <button class="gradient-tone-header btn formButton btn-block" type="submit" id="signup_button"  :disabled = "!isChecked || spinner" name="completesignupbutton">
                                                                Complete Sign Up
                                                                <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </panel>
                                    </accordion>
                                </div>
                            </transition>
                        </div>
                        <div class="col-md-5">
                            <div class="right-content">
                                <div class="gradient-tone-header jumbotron">
                                    <div class="hidemobile"><h2>Your Plan</h2><p>What You Get</p></div>
                                    <div class="showmobile"><h2>What You Get</h2></div>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="card">
                                    <!--<div class="card-header text-center">-->
                                    <!--<h3>-->
                                    <!--YOUR PLAN-->
                                    <!--</h3>-->
                                    <!--</div>-->
                                    <div class="card-block">
                                        <div class="list-group">
                                            <li v-if="dynamic_bullet_1" v-html="dynamic_bullet_1">
                                                <!--Personalized bite-sized expert videos will inspire you and set a positive TONE to your day-->
                                            </li>
                                            <li class="hidemobile" v-if="dynamic_bullet_2" v-html="dynamic_bullet_2">
                                                <!--A little dose of humor, and a pinch of inspiration each time you log on-->
                                            </li>
                                            <li v-if="dynamic_bullet_3" v-html="dynamic_bullet_3">
                                                <!--Reserve your spot for TONE Live... exclusive live streaming events with our credentialed expert-->
                                            </li>
                                            <li v-if="dynamic_bullet_4" v-html="dynamic_bullet_4">
                                                <!--Tune in to TONE Talks... our moderated discussions every Tuesday and Thursday night where we share advice within our community of women helping women!-->
                                            </li>
                                            <li v-if="dynamic_bullet_5" v-html="dynamic_bullet_5">
                                                <!--And did we mention you will be helping out a-->
                                                <!--charity every time you use the site?-->
                                            </li>
                                            <li v-if="dynamic_bullet_6" v-html="dynamic_bullet_6">
                                                <!--Look out for TONE Teasers... customized emails with videos selected just for you!-->
                                            </li>
                                            <!--<li v-if="!codeRedeemed" class="hidemobile">Try out TONE! Get a {{defaultPlan.type}} trial with your monthly membership, or {{annualPlan.type}} when you sign up for a year.</li>-->
                                            <!--<li v-if="!codeRedeemed" class="showmobile">Enjoy your free trial!</li>-->
                                        </div>
                                    </div>
                                    <!--<div class="card-footer hidemobile" >-->
                                    <!--<div class="list-group">-->
                                    <!--<li class="list-group-item">-->
                                    <!--<strong>{{defaultPlan.description}}</strong>-->
                                    <!--&lt;!&ndash;<input type="radio" name = "pkg" :value="defaultPlan.packageId" v-model="packageId" :checked="defaultPlan.packageId == packageId" />&nbsp;&nbsp;<strong>{{ defaultPlan.type }}</strong> (${{defaultPlan.amount}}) - {{defaultPlan.description}}&ndash;&gt;-->
                                    <!--</li>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showResetModal" class="watchVideoModal" effect="zoom" :value="showResetModal" @cancel="cancelResetModal()" width="200">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a href="javascript:">
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a href="javascript:" @click="cancelResetModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">


                <div class="text-center">
                    <h2 class="forgot-heading">
                        That Account Exists!
                    </h2>
                    <p><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></p>
                    <button class="btn formButton btn-transparent" @click="SetupLogin">
                        Sign In
                    </button>
                    <button class="btn formButton btn-transparent" @click="onSubmitForgetRequest">
                        Reset Password
                    </button>
                    <!--                    <button class="btn formButton btn-transparent" @click="cancelResetModal()">-->
                    <!--                        Go Back-->
                    <!--                    </button>-->
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { input, spinner, accordion, panel, alert, dropdown, radio, checkbox, tabs, tab, buttonGroup, modal } from 'vue-strap'
    import VuePassword from 'vue-password'
    import MaskedInput from 'vue-masked-input'
    import $ from 'jquery'
    import store from '../store'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'masked-input': MaskedInput,
            'panel': panel,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            modal
        },
        name: 'signUp',
        metaInfo () {
            let self = this
            return {
                title: 'TONE Networks | ' + self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                GifteeUser: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    packageId: 0,
                    phoneNumber: '',
                    comments: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png'
                },
                user: {
                    userId: 0,
                    email: '',
                    password: '',
                    firstName: '',
                    lastName: '',
                    cardHolderName: '',
                    phoneNumber: '',
                    packageId: '',
                    userPayments: [],
                    isPaypalCustomer: '',
                    paypalSubscriptionId: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png'
                },
//            paymentInfo: {
//                email: '',
//                packageId: '',
//                userPayments: []
//            },
                userPayments: {
                    token: '',
                    stripeCardId: '',
                    paymentType: 'CC',
                    paymentDate: new Date(),
                    paypalPayerId: '',
                    paypalPaymentId: '',
                    paymentMethodNonce: ''
                },
                emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
                phoneNumber: '',
                spinner: false,
                alert: false,
                passwordError: '',
                confirmPassword: '',
                stripe: '',
                card: '',
                panelStatus: false,
                createSection: true,
                paymentSection: false,
                isToggle: false,
                defaultPlan: '',
                isChecked: false,
                reqPlanCode: this.$route.params.planId ? this.$route.params.planId : '1MonthPlanChrgLate',
                daysToCancel: 0,
                isStripe: true,
                packageId: 0,
                // stripeKey: process.env.NODE_ENV !== 'development' ? 'sk_live_KO9T0KeJN7rWRXtYKSzju5KI' : 'sk_live_KO9T0KeJN7rWRXtYKSzju5KI',
//                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo', // For local testing
                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                gateway: 'CC',
                paypalPayerID: '',
                paypalPaymentId: '',
                paypalToken: '',
                // paypalObject: window.paypal.Button,
                paypalResponse: '',
                giftCode: '',
                codeRedeemed: false,
                stripeErrorMessage: '',
                hidePasswordMeter: true,
                isMonthlySubscription: true,
                isAnnualSubscription: false,
                annualPlan: '',
                twoYearPlan: '',
                planAmount: 0,
                showPlanForm: false,
                currentPlanSelection: '',
                isFreePreviewEnabled: false,
                implementFreePlan: false,
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_bullet_4: '',
                dynamic_bullet_5: '',
                dynamic_bullet_6: '',
                rawPhoneNumber: '',
                freeServiceFlag: false,
                paidServiceFlag: false,
                showResetModal: false,
                metaTag_pageTitle: 'TONE Networks | Sign-up',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
            }
        },
        mounted () {
//            navigator.__defineGetter__('userAgent', function () {
//                return 'gonative'
//            })
            // Redirection in case of NativeApp & Gift Redeem
            if (navigator.userAgent.indexOf('gonative') > -1) { // Native app
                this.$router.push('/joinnative')
            } else if (this.getCorporateClient) {
                if (this.getCorporateClient.invitationCode === '2') {
                    this.$router.push(`/corporation/referral/buy/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                } else {
                    this.$router.push(`/corporationgifting/${this.getCorporateClientId}/${this.getCorporateGiftingCode}`)
                }
            }
            this.$store.dispatch('GETDYNAMICCONTENTS', 4).then(() => {
                if (this.getAllSiteContents) {
                    this.dynamic_bullet_1 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_1')
                    this.dynamic_bullet_2 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_2')
                    this.dynamic_bullet_3 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_3')
                    this.dynamic_bullet_4 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_4')
                    this.dynamic_bullet_5 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_5')
                    this.dynamic_bullet_6 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_6')
                    // SEO Settings
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
            this.$store.dispatch('GETAPPCONFIGRATION').then(() => {
                let freeService = this.getFreePreviewStatus
                let paidService = this.getPaidMembershipFlag
                if (freeService === 1) {
                    this.freeServiceFlag = true
                } else {
                    this.freeServiceFlag = false
                }
                if (paidService === 1) {
                    this.paidServiceFlag = true
                } else {
                    this.paidServiceFlag = false
                }
                // this.freeServiceFlag = freeService
                // this.paidServiceFlag = paidService
                console.log('free service', this.freeServiceFlag)
                console.log('paid service', this.paidServiceFlag)

                if (freeService === 1 && paidService === 1) {
                    this.isFreePreviewEnabled = true
                    this.togglePlanView('trial')
                } else if (freeService === 1 && paidService === 0) {
                    this.togglePlanView('trial')
                    this.isFreePreviewEnabled = true
                    this.showPlanForm = true
                    this.implementFreePlan = true
                } else if (freeService === 0 && paidService === 1) {
                    this.togglePlanView('buy')
                    this.showPlanForm = true
                    this.mountStripeElement()
                } else {
                    this.togglePlanView('trial')
                    this.isFreePreviewEnabled = true
                    this.showPlanForm = true
                    this.implementFreePlan = true
                    this.freeServiceFlag = true
                    this.paidServiceFlag = false
                }
                // if (this.getFreePreviewStatus === 1) {
                //     this.isFreePreviewEnabled = true
                //     this.togglePlanView('trial')
                // } else {
                //     this.isFreePreviewEnabled = false
                //     this.showPlanForm = true
                //     this.mountStripeElement()
                // }
//                this.isFreePreviewEnabled = true
//                this.showPlanForm = false
            })
            this.$store.dispatch('GETPLAN', this.reqPlanCode).then(() => {
                // console.log('all plans', this.getAllPlans)
                this.defaultPlan = this.getDefaultPlan
                // this.user.packageId = this.getDefaultPlan.packageId
                // this.packageId = this.getDefaultPlan.packageId
            })
            this.$store.dispatch('GETPLANS').then(() => {
                // Get annual Plan
                let annualPlan = this.getAllPlans.filter(x => {
                    return x.packageId === 32
                })
                if (annualPlan && annualPlan.length > 0) {
                    this.annualPlan = annualPlan[0]
                    this.packageId = this.annualPlan.packageId
                    this.user.packageId = this.annualPlan.packageId
                    this.planAmount = this.annualPlan.amount
                }
                // Get two years plan
                let twoYearPln = this.getAllPlans.filter(x => {
                    return x.packageId === 30
                })
                if (twoYearPln && twoYearPln.length > 0) {
                    this.twoYearPlan = twoYearPln[0]
                }
            })
            this.$store.dispatch('GETPAYPALTOKEN')
//            if (!this.isFreePreviewEnabled) {
//                console.log('status', this.isFreePreviewEnabled)
//                console.info('free preview disabled')
//                this.mountStripeElement()
//            }
            $(':input').blur(function () {
                if ($(this).attr('name') !== 'password' && $(this).attr('id') !== 'signuptermsconditionschckbox') {
                    if ($(this).val().length > 0) {
                        // console.log($(this).attr('name'), $(this).val())
                        window.logEvents('Signup Page', 'Signup Page: Field.' + $(this).attr('name'), 'Signup Page: Field.' + $(this).attr('name') + ', val: ' + $(this).val())
                        // _gaq.push(['_trackEvent', 'INSERT FORM NAME HERE', 'completed', $(this).attr('name')])
                    } else {
                        // console.log($(this).attr('name') + ' Skipped', '')
                        window.logEvents('Signup Page', 'Signup Page: Field.' + $(this).attr('name'), 'Signup Page: Field.' + $(this).attr('name') + ', val: ' + 'skipped')
                        // _gaq.push(['_trackEvent', 'INSERT FORM NAME HERE', 'skipped', $(this).attr('name')])
                    }
                }
            })
        },
        methods: {
            SetupLogin () {
                this.showResetModal = false
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            cancelResetModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showResetModal = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            onSubmitForgetRequest () {
                var self = this
                console.log('email', self.user.email)
                // this.spinnerToggle()
                this.$store.dispatch('FORGOTPASSWORD', {user: self.user}).then(() => {
                    // this.spinnerToggle()
                    if (self.error.show) {
                        self.$swal({
                            title: self.error.message,
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.cancelResetModal()
                                }
                            }
                        )
                    } else {
                        self.$swal({
                            title: 'Forgot Password Request Sent! Check your email and follow the reset link',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                    self.cancelResetModal()
                                }
                            }
                        )
                    }
                })
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            togglePlanView (type) {
                if (type === this.currentPlanSelection) {
                } else {
                    this.currentPlanSelection = type
                    this.showPlanForm = !this.showPlanForm
                    setTimeout(() => {
                        this.showPlanForm = true
                    }, 500)
                    if (type === 'buy') {
                        this.implementFreePlan = false
                        this.mountStripeElement()
                    } else {
                        this.implementFreePlan = true
                    }
                }
            },
            applyActiveClass (type) {
                if (this.currentPlanSelection === type) {
                    return true
                } else {
                    return false
                }
            },
            mountbraintree () {
                let self = this
                if (self.getPaypalToken) {
                    window.braintree.client.create({
                        authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                    }, function (clientErr, clientInstance) {
                        // Stop if there was a problem creating the client.
                        // This could happen if there is a network error or if the authorization
                        // is invalid.
                        if (clientErr) {
                            console.error('Error creating client:', clientErr)
                            return
                        }
                        // Create a PayPal Checkout component.
                        window.braintree.paypalCheckout.create({
                            client: clientInstance
                        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                            // Stop if there was a problem creating PayPal Checkout.
                            // This could happen if there was a network error or if it's incorrectly
                            // configured.
                            if (paypalCheckoutErr) {
                                console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
                                return
                            }
                            // Set up PayPal with the checkout.js library
                            window.paypal.Button.render({
                                env: 'production', // or 'sandbox'
                                payment: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'vault',
                                        amount: self.planAmount,
                                        currency: 'USD',
                                        intent: 'sale'
                                        // Your PayPal options here. For available options, see
                                        // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                                    })
                                },
                                onAuthorize: function (data, actions) {
                                    return paypalCheckoutInstance.tokenizePayment(data)
                                        .then(function (payload) {
                                            // console.log('nonce', payload.nonce)
                                            // Submit `payload.nonce` to your server.
                                            self.userPayments.paymentMethodNonce = payload.nonce
                                        })
                                },
                                onCancel: function (data) {
                                    // console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
                                },
                                onError: function (err) {
                                    console.error('checkout.js error', err)
                                }
                            }, '#paypal-button').then(function () {
                                // The PayPal button will be rendered in an html element with the id
                                // `paypal-button`. This function will be called when the PayPal button
                                // is set up and ready to be used.
                            })
                        })
                    })
                }
            },
            redeemCode () {
                if (this.giftCode && this.giftCode.length > 0) {
                    this.spinnerToggle()
                    this.$store.dispatch('GETGIFTEE', this.giftCode).then(() => {
                        this.spinnerToggle()
                        if (this.getGiftee) {
                            this.user.firstName = this.getGiftee.gifteeFirstName
                            this.user.lastName = this.getGiftee.gifteeLastName
                            this.user.email = this.getGiftee.gifteeEmail
                            this.user.packageId = this.getGiftee.packageId
                            this.user.comments = this.getGiftee.gifteeUuid
                            this.codeRedeemed = true
                            this.$store.dispatch('GETPLANS').then(() => {
                                let plan = this.getAllPlans.filter(pln => {
                                    return pln.packageId === this.getGiftee.packageId
                                })
                                this.defaultPlan = plan[0]
                            })
                        }
                    })
                }
            },
            togglePaymentMethods () {
                if (this.gateway === 'paypal') {
                    this.isStripe = false
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.isStripe = true
                    this.mountStripeElement()
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                    this.isToggle = false
                    this.spinnerToggle()
                    this.$store.dispatch('VERIFYUSEREXISTS', {email: this.user.email}).then(() => {
                        this.spinnerToggle()
                        if (!this.error.show) {
                            this.isToggle = true
                            this.createSection = false
                            this.paymentSection = true
                            this.user.cardHolderName = this.user.firstName + ' ' + this.user.lastName
                            // mount strip element
                            this.isStripe = true
                            this.gateway = 'CC'
                            this.mountStripeElement()
                        }
                    })
                }
                // this.$router.push('/interestlist')
            },
            mountStripeElement () {
                // let stripeKey = this.stripeKey
                setTimeout(() => {
                    this.stripe = window.Stripe(this.stripeKey)
                    const elements = this.stripe.elements()
                    this.card = elements.create('card')
                    this.card.mount('#card-element')
                }, 1200)
            },
//            mountPayPalElement () {
//                var amount = this.defaultPlan.amount
//                window.paypal.Button.render({
//                    env: 'sandbox', // sandbox | production
//
//                    // PayPal Client IDs - replace with your own
//                    // Create a PayPal app: https://developer.paypal.com/developer/applications/create
//                    client: {
//                        sandbox: 'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R',
//                        production: 'Abcr096coCh2Ll2yRPSHi9t2e0XFS4MUtZtnar6JbU5oi9JrqLDfl7pXsrizBwzV21R-nQhnZZCNPLZa'
//                    },
//
//                    // Show the buyer a 'Pay Now' button in the checkout flow
//                    commit: true,
//
//                    // payment() is called when the button is clicked
//                    payment: function (data, actions) {
//                        // Make a call to the REST api to create the payment
//                        return actions.payment.create({
//                            payment: {
//                                transactions: [
//                                    {
//                                        amount: { total: amount, currency: 'USD' }
//                                    }
//                                ]
//                            }
//                        })
//                    },
//                    // onAuthorize() is called when the buyer approves the payment
//                    onAuthorize: function (data, actions) {
//                        if (sessionStorage.getItem('paypalToken')) {
//                            sessionStorage.removeItem('paypalToken')
//                            sessionStorage.setItem('paypalToken', data.paymentToken)
//                        } else {
//                            sessionStorage.setItem('paypalToken', data.paymentToken)
//                        }
//                        if (sessionStorage.getItem('paypalPaymentID')) {
//                            sessionStorage.removeItem('paypalPaymentID')
//                            sessionStorage.setItem('paypalPaymentID', data.paymentID)
//                        } else {
//                            sessionStorage.setItem('paypalPaymentID', data.paymentID)
//                        }
//                        if (sessionStorage.getItem('paypalPayerID')) {
//                            sessionStorage.removeItem('paypalPayerID')
//                            sessionStorage.setItem('paypalPayerID', data.payerID)
//                        } else {
//                            sessionStorage.setItem('paypalPayerID', data.payerID)
//                        }
//                    }
//                }, '#paypal-button-container')
//            },
            disablePaymentPanel () {
                this.panelStatus = false
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPassword () {
                if (this.user.password.length >= 6) {
                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                    if (!re.test(this.user.password)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (this.user.password.length > 0) {
                        return false
                    } else {
                        return true
                    }
//                if (this.user.password.length >= 6) {
//                    // [^ ]{8,16}
//                    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/
//                    let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
//                    if (!re.test(this.user.password)) {
//                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
                }
            },
            verifyEmail () {
                if (this.user.email.length > 0) {
                    // let re = /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i
                    let re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i
                    if (!re.test(this.user.email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyFirstName () {
                if (this.user.firstName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.firstName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyLastName () {
                if (this.user.lastName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.lastName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyCardHolderName () {
                if (this.user.cardHolderName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.cardHolderName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onPaymentSubmit () {
                let self = this
                if (this.codeRedeemed) {
                    if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                        this.GifteeUser.firstName = this.user.firstName
                        this.GifteeUser.lastName = this.user.lastName
                        this.GifteeUser.email = this.user.email.toLowerCase()
                        this.GifteeUser.password = this.user.password
                        this.GifteeUser.packageId = this.getGiftee.packageId
                        this.GifteeUser.comments = this.getGiftee.gifteeUuid
                        if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                            this.GifteeUser.phoneNumber = this.phoneNumber
                        } else {
                            this.phoneNumber = ''
                            this.GifteeUser.phoneNumber = ''
                        }
                        this.spinnerToggle()
                        this.$store.dispatch('SAVEGIFTEE', {giftee: this.GifteeUser}).then(() => {
                            if (!this.error.show) {
                                this.spinnerToggle()
                                this.$swal({
                                    title: 'Registration Success!',
                                    text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'sweetalert-lg-signup'
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                this.spinnerToggle()
                                if (this.error.show) {
                                    console.log('error', this.error.message)
                                    if (this.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                        this.showResetModal = true
                                        // self.$fire({
                                        //     title: 'That Account Exists',
                                        //     width: 600,
                                        //     text: '',
                                        //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                        //     showCancelButton: true,
                                        //     confirmButtonColor: '#44bda8',
                                        //     cancelButtonColor: '#44bda8',
                                        //     confirmButtonText: '   Sign In   ',
                                        //     cancelButtonText: 'Reset Password',
                                        //     showCloseButton: true
                                        // }).then((result) => {
                                        //     if (result.value) {
                                        //         store.commit('setTriggerLogin', {loginStatus: true})
                                        //     } else if (result.dismiss === 'cancel') {
                                        //         self.onSubmitForgetRequest()
                                        //     }
                                        // })
                                    } else {
                                        this.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: this.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    }
                                }
                            }
                        })
                    }
                } else if (this.isFreePreviewEnabled && this.currentPlanSelection === 'trial') {
                    console.info('inside free preview')
                    this.user.email = this.user.email.toLowerCase()
                    if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                        this.user.phoneNumber = this.phoneNumber
                    } else {
                        this.phoneNumber = ''
                        this.user.phoneNumber = ''
                    }
                    if (this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName()) {
                        this.spinnerToggle()
                        this.user.userPayments = []
                        this.$store.dispatch('SAVEUSERWITHFREETIRAL', {newUser: this.user}).then(() => {
                            if (!this.error.show) {
                                this.spinnerToggle()
                                this.$swal({
                                    title: 'Registration Success!',
                                    text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'sweetalert-lg-signup'
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                this.spinnerToggle()
                                if (this.error.show) {
                                    console.log('error', this.error.message)
                                    if (this.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                        this.showResetModal = true
                                        // self.$fire({
                                        //     title: 'That Account Exists',
                                        //     width: 600,
                                        //     text: '',
                                        //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                        //     showCancelButton: true,
                                        //     confirmButtonColor: '#44bda8',
                                        //     cancelButtonColor: '#44bda8',
                                        //     confirmButtonText: '   Sign In   ',
                                        //     cancelButtonText: 'Reset Password',
                                        //     showCloseButton: true
                                        // }).then((result) => {
                                        //     if (result.value) {
                                        //         store.commit('setTriggerLogin', {loginStatus: true})
                                        //     } else if (result.dismiss === 'cancel') {
                                        //         self.onSubmitForgetRequest()
                                        //     }
                                        // })
                                    } else {
                                        this.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: this.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    }
                                }
                            }
                        })
                    }
                } else {
                    if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                        this.user.phoneNumber = this.phoneNumber
                    } else {
                        this.phoneNumber = ''
                        this.user.phoneNumber = ''
                    }
                    if (this.gateway !== 'CC') {
                        this.user.cardHolderName = ' '
                    }
                    if (this.user && this.verifyPassword() && this.verifyEmail() && this.verifyFirstName() && this.verifyLastName() && this.verifyCardHolderName()) {
                        this.spinnerToggle()
                        this.user.email = this.user.email.toLowerCase()
                        this.$store.dispatch('VERIFYUSEREXISTS', {email: this.user.email}).then(() => {
                            if (!this.error.show) {
                                if (this.gateway === 'CC') {
                                    this.stripe.createToken(this.card).then((result) => {
                                        if (result.error) {
                                            this.spinnerToggle()
                                            // Inform the user if there was an error
                                            // $(this.$el).find('#card-errors')
                                            // var errorElement = document.getElementById('card-errors')
                                            self.stripeErrorMessage = result.error.message
                                        } else {
                                            // Send the token to your server
                                            const stripeToken = result.token.id
                                            const cardId = result.token.card.id
                                            // console.log('token', stripeToken)
                                            this.userPayments.token = stripeToken
                                            this.userPayments.stripeCardId = cardId
                                            if (this.user.userPayments.length > 0) {
                                                this.user.userPayments.pop()
                                            }
                                            this.user.userPayments.push(this.userPayments)
                                            if (stripeToken) {
                                                this.$store.dispatch('SIGNUPWITHPAYMENTPLAN', {user: this.user}).then(() => {
                                                    if (!this.error.show) {
                                                        this.spinnerToggle()
                                                        this.$swal({
                                                            title: 'Registration Success!',
                                                            text: 'Welcome To TONE! For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                                            type: 'success',
                                                            timer: 4000,
                                                            showCancelButton: false,
                                                            showConfirmButton: false,
                                                            customClass: 'sweetalert-lg-signup'
                                                        }).then(
                                                            function () {
                                                            },
                                                            // handling the promise rejection
                                                            function (dismiss) {
                                                                if (dismiss === 'timer') {
                                                                }
                                                            }
                                                        )
                                                    } else {
                                                        this.spinnerToggle()
                                                    }
                                                })
                                            }
                                        }
                                    })
                                } else if (this.userPayments.paymentMethodNonce) {
                                    if (this.user.userPayments.length > 0) {
                                        this.user.userPayments.pop()
                                    }
                                    this.user.userPayments.push(this.userPayments)
                                    if (this.userPayments.paymentMethodNonce) {
                                        this.$store.dispatch('SIGNUPWITHPAYMENTPLAN', {user: this.user}).then(() => {
                                            if (!this.error.show) {
                                                this.spinnerToggle()
                                                this.$swal({
                                                    title: 'Registration Success!',
                                                    text: 'For your security, please check your inbox for a TONE Action Needed email within the next 12 hours. (Don’t see it? Check your spam folder.)',
                                                    type: 'success',
                                                    timer: 4000,
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'sweetalert-lg-signup'
                                                }).then(
                                                    function () {},
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else {
                                                this.spinnerToggle()
                                                if (this.error.show) {
                                                    console.log('error', this.error.message)
                                                    if (this.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                                        this.showResetModal = true
                                                        // self.$fire({
                                                        //     title: 'That Account Exists',
                                                        //     width: 600,
                                                        //     text: '',
                                                        //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                                        //     showCancelButton: true,
                                                        //     confirmButtonColor: '#44bda8',
                                                        //     cancelButtonColor: '#44bda8',
                                                        //     confirmButtonText: '   Sign In   ',
                                                        //     cancelButtonText: 'Reset Password',
                                                        //     showCloseButton: true
                                                        // }).then((result) => {
                                                        //     if (result.value) {
                                                        //         store.commit('setTriggerLogin', {loginStatus: true})
                                                        //     } else if (result.dismiss === 'cancel') {
                                                        //         self.onSubmitForgetRequest()
                                                        //     }
                                                        // })
                                                    } else {
                                                        this.$swal({
                                                            title: 'An Error occurred while processing the request',
                                                            text: this.error.message,
                                                            type: 'error',
                                                            timer: 3000,
                                                            showCancelButton: false,
                                                            showConfirmButton: false
                                                        }).then(
                                                            function () {
                                                            },
                                                            // handling the promise rejection
                                                            function (dismiss) {
                                                                if (dismiss === 'timer') {
                                                                }
                                                            }
                                                        )
                                                    }
                                                }
                                            }
                                        })
                                    }
                                } else {
                                    this.spinnerToggle()
                                    if (this.error.show) {
                                        console.log('error', this.error.message)
                                        if (this.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                            this.showResetModal = true
                                            // self.$fire({
                                            //     title: 'That Account Exists',
                                            //     width: 600,
                                            //     text: '',
                                            //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                            //     showCancelButton: true,
                                            //     confirmButtonColor: '#44bda8',
                                            //     cancelButtonColor: '#44bda8',
                                            //     confirmButtonText: '   Sign In   ',
                                            //     cancelButtonText: 'Reset Password',
                                            //     showCloseButton: true
                                            // }).then((result) => {
                                            //     if (result.value) {
                                            //         store.commit('setTriggerLogin', {loginStatus: true})
                                            //     } else if (result.dismiss === 'cancel') {
                                            //         self.onSubmitForgetRequest()
                                            //     }
                                            // })
                                        } else {
                                            this.$swal({
                                                title: 'An Error occurred while processing the request',
                                                text: this.error.message,
                                                type: 'error',
                                                timer: 3000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(
                                                function () {
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                    }
                                                }
                                            )
                                        }
                                    }
                                }
                            } else {
                                if (this.error.show) {
                                    console.log('error', this.error.message)
                                    if (this.error.message.toString().toLowerCase().indexOf('already exists') > -1) {
                                        this.showResetModal = true
                                        // self.$fire({
                                        //     title: 'That Account Exists',
                                        //     width: 600,
                                        //     text: '',
                                        //     html: '<span font-size:24px;!important"><strong>You have an account with Tone Networks. Please try logging in or resetting your password.</strong></span><br><br>',
                                        //     showCancelButton: true,
                                        //     confirmButtonColor: '#44bda8',
                                        //     cancelButtonColor: '#44bda8',
                                        //     confirmButtonText: '   Sign In   ',
                                        //     cancelButtonText: 'Reset Password',
                                        //     showCloseButton: true
                                        // }).then((result) => {
                                        //     if (result.value) {
                                        //         store.commit('setTriggerLogin', {loginStatus: true})
                                        //     } else if (result.dismiss === 'cancel') {
                                        //         self.onSubmitForgetRequest()
                                        //     }
                                        // })
                                    } else {
                                        this.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: this.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    }
                                }
                                this.spinnerToggle()
                            }
                        })
                    }
                }
            }
        },
        computed: {...mapGetters([
            'error', 'isUserLoggedIn', 'getDefaultPlan', 'getGiftee', 'getAllPlans', 'getPaypalToken', 'getFreePreviewStatus', 'getTotalTrialDays', 'getAllSiteContents', 'getCorporateClient', 'getCorporateClientId', 'getCorporateGiftingCode', 'getPaidMembershipFlag'])
        },
        watch: {
            'user.firstName' (to, from) {
                this.user.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
            },
            'user.lastName' (to, from) {
                this.user.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
            },
            'packageId' (to, from) {
                this.user.packageId = this.packageId
                if (this.packageId === 32) {
                    this.planAmount = this.annualPlan.amount
                } else if (this.packageId === 30) {
                    this.planAmount = this.twoYearPlan.amount
                } else {
                    this.planAmount = this.defaultPlan.amount
                }
//                console.log('package', this.packageId)
//                console.log('user package', this.user.packageId)
//                console.log('Plan Amount', this.planAmount)
            },
//            'isAnnualSubscription' (to, from) {
//                this.isMonthlySubscription = !this.isAnnualSubscription
//                if (this.isAnnualSubscription) {
//                    this.user.packageId = this.annualPlan.packageId
//                } else {
//                    this.user.packageId = this.defaultPlan.packageId
//                }
//            },
            'gateway' (to, from) {
                if (this.gateway === 'paypal') {
                    this.card.unmount('#card-element')
                    this.stripeErrorMessage = ''
                    this.isStripe = false
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.userPayments.paymentType = 'PayPal'
                    this.user.isPaypalCustomer = '1'
                    this.userPayments.paymentMethodNonce = ''
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.stripeErrorMessage = ''
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.user.isPaypalCustomer = '0'
                    this.userPayments.paymentType = 'CC'
                    this.userPayments.paymentMethodNonce = ''
                    this.isStripe = true
                    setTimeout(() => {
                        this.mountStripeElement()
                    }, 1000)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .gradient-tone-header {
        /* TT-1039- REBRANDING */
        background: linear-gradient(
            to right,
            #44bda8 0%,
            #3aa9a7 30%,
            #2f8f9f 60%,
            #004573 100%
        ) !important;
    }
    .set-error{
        border-color: #a94442 !important;
        color:#a94442 !important;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0 0px 10px;
        color: #f0617d;
    }
    div#paypal-button {
        text-align: center;
    }
    .codediv {
        padding: 10px 0 0;
    }
    .codediv + .row.code {
        padding-top: 0;
    }
    @media(min-width:768px) {
        .row.code + label.terms-and-condition {
            margin: 0;
        }
    }
    .stripeholder {}

    .codediv .stripeholder {
        margin-bottom: 20px;
    }

    .codediv .col-md-12 {
        min-height: 0;
    }
    .showmobile{
        display:none;
    }
    .stripeholder {
        position: relative;
    }

    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    button.redeem.btn.formButton.btn-block {
        margin: 0;
    }

    .row.code {
        padding-top: 20px;
    }
    @media(max-width:479px){
        .innerpart {
            font-size: 17px;
            letter-spacing: 0;
        }
    }
    @media (max-width:767px){
        .hidemobile{
            display:none;
        }
        .showmobile{
            display:inherit;
        }
        .signUp .left-content h4 {
            font-size: 14px;
            letter-spacing: 0px;
        }

        .signUp .main-content h2 {
            margin: 15px 0;
            line-height: 20px;
            font-size: 18px;
        }

        .signUp #signup_pwderrormsg {
            margin-bottom: 8px;
            line-height: 1.3;
            letter-spacing: 1px;
        }

        .signUp .left-content .create-account #signup_button {
            margin: 0;
        }

        .signUp .right-content .jumbotron {
            padding: 6px;
            margin-top: 7px;
        }

        .signUp .right-content .jumbotron h2 {
            margin: 0;
            font-size: 21px;
        }

        .signUp .right-content .jumbotron p {
            display: none;
        }

        .signUp .right-content .card {
            padding: 10px 10px;
        }

        .signUp .right-content .card .card-block .list-group li {
            font-size: 16px;
            margin: 0 0 10px;
        }

        .signUp .left-content hr {
            display: none;
        }

        .row.margin-top {
            margin-top: 0px;
        }
        div#paypal-button {
            text-align: center!important;
            top: -3px;
        }
        .codediv .stripeholder {
            margin-bottom: 10px;
        }

    }

    /* Media query for mobile viewport */
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /* Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    button.redeem.btn.formButton.btn-block {
        letter-spacing: 0;
    }
    .checkboxholder {
        padding-bottom: 10px;
    }
    .checkboxholder .checkbox {
        font-size: 16px;
        letter-spacing: 3px;
        margin: 15px 0;
    }
    .redoutlinebox {
        border: 2px solid #f0617d;
        padding: 10px;
        margin: 0px 0px 20px;
        text-align: justify;
    }
    .checkboxholder .radio input[type="radio"] {
        opacity:1;
        z-index:20;
        top: 2px;
    }
    body .margin-top {
        margin-top: 89px;
        margin-bottom: 70px;
    }
    body .signUp .right-content .card .card-block .list-group{
        margin-bottom:0px;
    }
    .choice-holder {
        border: 1px solid #ddd;
        margin: 0 0 20px;
        padding: 20px 0;
        font-size: 16px;
        font-weight: 500;
    }

    .choice-holder .btn {
        margin: 10px auto;
    }
    .innerpart {
        margin: auto;
        max-width: 220px;
        padding: 0 10px;
    }
    .choice-holder > .row {
        margin: 0;
    }

    .choice-holder > .row > .col-xs-6 {
        padding: 0;
    }
    span.heading {
        position: relative;
        width: 100%;
        display: block;
        font-size: 19px;
        font-weight: 500;
        color: #a9a9a9;
    }

    .checkboxholder .radio {
        text-align: center;
        border: 1px solid #ddd;
        padding: 10px;
    }

    .checkboxholder {}

    .checkboxholder .radio label {
        padding: 0;
        letter-spacing: 0;
    }

    .checkboxholder .radio label span {
        display: block;
    }

    .checkboxholder .radio label input {
        position: relative;
        margin: 20px 0;
    }
    span.footertext {
        font-weight: 500;
        color: #a9a9a9;
    }

    span.plan-price {
        font-size: 34px;
        font-weight: 900;
        color: #a9a9a9;
    }
    .radio.popular:before {
        content: "Most Popular Deal";
        position: absolute;
        left: 0;
        right: 0;
        line-height: 1.3;
        background: #f0617d;
        color: #fff;
        transform: translatey(-100%);
        margin-top: -10px;
        padding: 5px 0;
    }

    .checkboxholder {
        padding-top: 30px;
    }
    span.permonth {
        display: block;
        font-size: 14px;
    }

    span.plan-price {
        line-height: 1.2;
        padding-top: 20px;
    }
    @media(max-width:767px){
        .radio.popular[data-v-3a43d266]:before {
            position: absolute;
            transform: translateY(-20px);
        }

        .radio.popular {
            padding-top: 30px !important;
        }
    }
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    /*.bounce-leave-active {*/
    /*animation: bounce-in .1s reverse;*/
    /*}*/
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
</style>



// WEBPACK FOOTER //
// SignUp.vue?01f55ed9